<template>

  <div>
    <my-header> </my-header>
    <div class="mainWrap">
      <div class="main">
        <div class="breadCrumbs">
          <h3>{{odercenter}}</h3>
          <span>
            <router-link to="/">
              <a>首页</a> &gt;
            </router-link>
            <!--  <a @click="product()">产品</a> -->
            <em>{{odercenter}}</em>
          </span>
        </div>
        <!--内容开始-->
        <div class="content"
             v-if="loading">

          <div class="shopp-content">

            <div class="shopping">

              <div class="jindu">

                <ul>
                  <li class="cur"><span>1</span>1.填写核对订单信息</li>
                  <li class="li02"><span>2</span>2.提交订单完成</li>
                </ul>

                <dl>
                  <h3>填写并核对订单信息</h3>
                  <p>请完善以下的信息：</p>
                </dl>

                <div class="del_float"></div>
              </div>
              <div class="consignee">
                <h3>收货人信息</h3>
              </div>
              <form id="formOrder"
                    action=""
                    method="post">
                <div class="address">
                  <h3><input checked="checked"
                           type="radio"
                           class="newadd"
                           name="radio5" /><span>使用新地址</span></h3>
                  <div class="addresshidden">
                    <ul>
                      <li><span>*收货人：</span><label><input type="text"
                                 v-model="message.Consignee"
                                 name="name"
                                 class="shr"
                                 id="txtName" /></label><em>为保障您的利益，请务必填写真实姓名，因为收货需验证真实身份</em></li>
                    </ul>
                    <dl>
                      <dt>*所在地区：</dt>
                      <dd class="addresshidden shengshiqu">

                        <!-- <v-distpicker
                          class='a'
                          v-show="true"
                          :province="message.area.province"
                          :city="message.area.city"
                          :area="message.area.dist"
                          @selected="pcdSelect"
                        > </v-distpicker> -->

                        <select class="a"
                                v-model="message.area.province"
                                @change="getcityList">
                          <option value=''
                                  disabled
                                  selected
                                  style='display:none;'>请选择省市</option>
                          <option :value="item.id"
                                  v-for="item in provinceList"
                                  :key="item .id">
                            {{item.name}}
                          </option>
                        </select>

                        <select class="b"
                                v-model="message.area.city"
                                @change="getdistList">
                          <option value=''
                                  disabled
                                  selected
                                  style='display:none;'>请选择城市</option>
                          <option :value="item.id"
                                  v-for="item in cityList"
                                  :key="item .id">
                            {{item.name}}
                          </option>
                        </select>
                        <select class="c"
                                v-model="message.area.dist">
                          <option value=''
                                  disabled
                                  selected
                                  style='display:none;'>请选择区县</option>
                          <option :value="item.id"
                                  v-for="item in distList"
                                  :key="item .id">
                            {{item.name}}
                          </option>
                        </select>

                      </dd>
                    </dl>
                    <ul>
                      <li><span>*详细地址：</span><label><input type="text"
                                 v-model="message.address"
                                 name="address"
                                 class="deadd"
                                 id="txtAddress" /></label><em>填写信息要完整，细致到市、区、街、号</em></li>
                      <li><span>*手机号码：</span><label><input type="text"
                                 v-model="message.tel"
                                 name="phone"
                                 class="Mobile"
                                 id="txtPhone" /></label></li>
                    </ul>
                  </div>
                </div>
                <div class="pay">
                  <h3>支付方式：</h3>
                  <p><input type="radio"
                           name="radio1"
                           checked="checked" /><span>在线支付：</span>
                    <em v-if=" this.message.pay==1">支付宝平台的支付方式。如果您已经拥有此平台的账号，可直接使用。</em>
                    <em v-if=" this.message.pay==2">微信平台的支付方式。请使用微信扫一扫，扫描二维码支付。</em>
                  </p>
                  <ul>
                    <li v-for="items in paylist"
                        :key="items.id"
                        v-bind:style="{backgroundImage:'url(' + items.backgroundImage + ')'}">

                      <input type="radio"
                             name="pay"
                             :value='items.id'
                             @click="payid(items)" />

                    </li>
                    <!-- <li class="yinlian"><input type="radio"
                  
                             name="pay"
                             value="2" /></li> -->

                  </ul>
                </div>
                <div class="distribution">
                  <h3>配送方式：<span>顺丰包邮（个别商品除外）</span></h3>
                  <p>温馨提示:将根据您的地理位置智能选择最适合便捷的快递服务。</p>
                </div>
                <div class="listing">商品清单：</div>

                <div class="shopp-container">

                  <div class="shopp-wrapper">

                    <div class="shoppingtitle">
                      <h4 class="name">商品</h4>
                      <h4 class="num"
                          v-if="ukey==0||ukey==null||oderstyle==1">单价</h4>
                      <h4 class="num"
                          v-if="ukey!=0&&oderstyle==0">会员单价</h4>
                      <h4 class="price">数量</h4>
                    </div>

                    <div class="probuy_threecon">
                      <ul class="proyes-wrapper">
                        <li v-if="this.$route.query.oderstyle!=1">
                          <div class="probuy probuy-one">
                            <img class="probuy_threeimg fl ml0"
                                 width="155"
                                 height="124"
                                 :src="httpurl+oderimg"
                                 alt="" />
                            <div class="crOrder">
                              <p class="pro_zhiwei">
                                {{productlist.name}}

                              </p>

                              <p v-show="productlist.iscolor!=0&&this.addprice!==0">
                                线材：
                                {{Xiancai.name}} ￥{{Xiancai.price*zk|toFixed(2)}}
                              </p>
                              <p v-show="productlist.iscolor==0||this.addprice==0">
                                线材:￥0
                              </p>
                              <p v-show="productlist.iscolor!=0&&this.addprice!==0">
                                包装盒：
                                {{Baozhuang.name}} ￥{{Baozhuang.price*zk|toFixed(2)}}
                              </p>
                              <p v-show="productlist.iscolor==0||this.addprice==0">
                                包装盒:￥0
                              </p>
                              <p v-show="productlist.iscolor==0||this.addprice==0">
                                面板颜色:￥0
                              </p>
                              <p v-show="productlist.iscolor!==0&&this.addprice!==0">
                                面板颜色:￥{{addprice*zk|toFixed(2)}}
                              </p>
                            </div>
                          </div>
                          <!-- <div class="probuy probuy-two"
                               width="190">
                            ￥{{productlist.price|toFixed(2)}}
                          </div> -->
                          <div class="probuy probuy-two"
                               width="190"
                               v-if="childid==-1">
                            ￥{{parseFloat(productlist.price)*zk|toFixed(2)}}
                          </div>
                          <div class="probuy probuy-two"
                               width="190"
                               v-if="childid!=-1">
                            ￥{{zhprice|toFixed(2)}}
                          </div>
                          <div class="probuy probuy-three"
                               v-show="productlist.iscolor==0">
                            1
                          </div>
                          <div class="probuy probuy-three"
                               v-show="productlist.iscolor!==0">
                            {{Pnumber}}
                          </div>

                        </li>
                        <li v-if="this.$route.query.oderstyle==1">
                          <div class="probuy probuy-one">
                            <img class="probuy_threeimg fl ml0"
                                 width="155"
                                 height="124"
                                 :src="httpurl+otherlist.spic"
                                 alt="" />
                            <div class="crOrder">
                              <p class="pro_zhiwei">
                                {{otherlist.title}}

                              </p>

                            </div>
                          </div>
                          <!-- <div class="probuy probuy-two"
                               width="190">
                            ￥{{productlist.price|toFixed(2)}}
                          </div> -->
                          <div class="probuy probuy-two"
                               width="190"
                               v-if="oderstyle!=1">
                            ￥{{orderprice|toFixed(2)}}
                          </div>
                          <div class="probuy probuy-two"
                               width="190"
                               v-if="oderstyle==1">
                            ￥{{zhprice|toFixed(2)}}
                          </div>
                          <div class="probuy probuy-three">
                            {{otherlist.sl}}
                          </div>

                        </li>
                      </ul>

                    </div>

                  </div>

                </div>

              </form>
              <div class="note-input">
                 <span>备注：</span><label><textarea type="text"
                                max-length="100"
                                 v-model="note"
                                 name="note"
                                 class="note"
                                 id="note" /></label>
              </div>
              <div class="probuy_list">
                <!-- <p class="probuy_three_price" v-if="ukey==0"><span>应付总额:</span>
                  ￥{{AllSum|toFixed(2)}}
                </p> -->
                <p class="probuy_three_price" id="price1"
                   v-if="oderstyle!=0&&oderstyle!=1"><span>应付总额:</span>
                  ￥{{zhprice|toFixed(2)}} <s>￥{{AllSum|toFixed(2)}}</s>
                </p>
                <p class="probuy_three_price" id="price2"
                   v-if="oderstyle==1"><span>应付总额:</span>
                  ￥{{zhprice|toFixed(2)}}
                </p>
                <p class="probuy_three_price" id="price3"
                   v-if="oderstyle==0"><span>应付总额:</span>
                   ￥{{zhprice|toFixed(2)}} <s v-if="(ukey!==0&&oderstyle==0)||childid!=-1">￥{{AllSum|toFixed(2)}}</s>
                  <s v-if="ukey!==0&&oderstyle!=0&&childid==-1">￥{{orderprice|toFixed(2)}}</s>
                </p>
                <p class="probuy_three_integral" @click="show()"
                   v-if="jyzshow">获得{{point}}经验值</p>
                <p class="probuy_three_jiesuan">
                  <a @click="payto()">结 算</a>
                </p>
              </div>
              
            </div>

          </div>

        </div>
        <!--内容结束-->
        <!-- <div  v-html="zfblist">
           {{zfblist}}
        </div> -->
      </div>
    </div>

    <!-- 
    <div class="qrcodebg">
    <div class="qrcodebox">
    <div id="qrcode" ref="qrcode">
      
    </div>
    </div>
    </div> -->

  </div>

</template>
<script>
import QRCode from 'qrcodejs2'
import { mapActions, mapGetters } from "vuex";
import VDistpicker from "v-distpicker";
import myHeader from "@/views/detailimg";
import { getregxx, gettjddxx, getregcs, getregqx, gzkxx, getotheroder, getyhaddress, getpoinxx, getpro } from "@/api/api";
export default {
  components: { myHeader, VDistpicker },
  data () {

    return {
        note:'',
      pay: '',
      loading: false,
      childid: -1,
      odershow: false,
      zhprice: '',
      zfblist: '',
      zfbshow: false,
      payname: '',
      oderimg: '',
      httpurl: "http://shop.qdc.com/",
      daohang: false, //显示导航
      screenWidth: document.body.clientWidth, // 屏幕尺寸
      odercenter: "订单中心",
      message: {
        Consignee: "",
        area: {
          province: '',
          city: "",
          dist: ""
        },
        address: "",
        tel: "",
        pay: '',
      },
      provinceList: [

      ],
      cityList: [

      ],
      distList: [],
      paycodeimg: false,
      paylist: [{
        id: 1,
        name: '支付宝',
        backgroundImage: require("../assets/cr_qlpic11.jpg"),
      },
      {
        id: 2,
        name: '微信',
        backgroundImage: require("../assets/cr_qlpic12.jpg"),
      }],
       wxpaylist: [
      {
        id: 2,
        name: '微信',
        backgroundImage: require("../assets/cr_qlpic12.jpg"),
      }],
      provinceSelected: "",
      addinfo: {
        elseask: "",
        name: "",
        quality: "",
        style: ""
      },
      YwwpicRight: {
        imageid: '',
      },
      YwwLagre: {
        imageid: '',
      },
      Baozhuang: {
        id: '',
      },
      Xiancai: {
        id: '',
      },
      lcolorid: '',
      iscolor: '',
      codeurl: '',
      ukey: 0,
      weixin: '',
      otherlist: '',
      zk: 1,
      oderstyle: 0,
      orderprice: '',
      productlist: '',
      jyzshow: false,
      proid: '',
      point:'',
      addprice: 0
    };
  },

  computed: {
  },
  created () {
    // console.log('this.addprice:::' + this.productlist)
    if (localStorage.getItem('addprice')) {
      this.addprice = localStorage.getItem('addprice')
    }
     if(this.$route.query.type){
        this.zhprice=sessionStorage.getItem("newchooseprice")
    }

    if (this.$route.query.childid ) {

      this.getproductlist()
      this.loading = true
      this.childid = this.$route.query.childid
    } else {

      this.childid = -1
    }
    if (this.$route.query.oderstyle != 1) {
        if(this.$route.query.oderstyle == 0){
             console.log('this.$route.query.productmoreid1:'+this.$route.query.productmoreid)
              if(this.$route.query.type){
        this.zhprice=sessionStorage.getItem("newchooseprice")
    }
             var list = JSON.parse(localStorage.getItem('prpductnewlist'));
             if(sessionStorage.getItem("newchooseprice")){
                   this.zhprice=sessionStorage.getItem("newchooseprice")
             }
           if(this.$route.query.productmoreid == 1){
               this.zhprice=list.cprice
           
            
        }else if(this.$route.query.productmoreid == 2){
             this.zhprice=list.aprice

        }
        else if(this.$route.query.productmoreid == 3){
            console.log("type:"+this.$route.query.type)
            this.zhprice=list.bprice
        }
        }else{
            if (this.$route.query.iscolor == 1 && !this.$route.query.productmoreid) {
        var list = JSON.parse(localStorage.getItem('prpductnewlist'));
       console.log('this.zhprice:'+this.zhprice)
        this.oderimg = list.image
      } else {
          
        if (localStorage.getItem('newYwwLagre')) {
          var newYwwLagre = JSON.parse(localStorage.getItem('newYwwLagre'));
          this.oderimg = newYwwLagre.image
          console.log('this.$route.query.productmoreid2:'+this.$route.query.productmoreid)
           this.zhprice=sessionStorage.getItem("newchooseprice")
          this.getproductlist()
        }

      }

        }
         
    
      
    }

    if (localStorage.getItem("prpductnewlist") != null) {

      var list = JSON.parse(localStorage.getItem('prpductnewlist'));
      this.productlist = list
      this.productid = list.id
      this.iscolor = list.iscolor
       if(this.$route.query.type){
        this.zhprice=sessionStorage.getItem("newchooseprice")
    }
      if (this.$route.query.childid&&this.$route.query.productmoreid) {
            if(this.$route.query.productmoreid == 1){
            this.zhprice=list.cprice
        }else if(this.$route.query.productmoreid == 2){
            this.zhprice=list.aprice
        }
        else if(this.$route.query.productmoreid == 3){
            this.zhprice=list.bprice
        }
      }
      if (list.iscolor == 0) {
        this.YwwpicRight.imageid = 0;//产品颜色id(右耳)

        this.Xiancai.id = 0;//线材id
        this.Baozhuang.id = 0;//包装盒id
        this.addinfo.name = '';//包装盒刻字
        this.addinfo.style = '';//款式
        this.addinfo.quality = '';//材质
        this.addinfo.elseask = '';//其他要求
        this.lcolorid = 0;
      }
      if (list.iscolor == 1) {
        this.addinfo = JSON.parse(localStorage.getItem('newaddinfo'));
        if (this.$route.query.productmoreid) {
          var newAllSum = JSON.parse(localStorage.getItem('newAllSum'));
          this.zhprice = newAllSum
          this.AllSum = newAllSum / localStorage.getItem('discount')
          this.oderimg = list.image
          
        }
        if(this.$route.query.childid){
             var newAllSum = JSON.parse(localStorage.getItem('zhprice2'));
            this.zhprice = newAllSum
        }
         if(this.$route.query.type){
        this.zhprice=sessionStorage.getItem("newchooseprice")
    }

      }
    }
    if (localStorage.getItem("newChildproductlist") != null) {
      var list2 = JSON.parse(localStorage.getItem('newChildproductlist'));
      this.productname = list2.name
    }
    if (localStorage.getItem("newYwwLagre") != null) {
      var newYwwLagre = JSON.parse(localStorage.getItem('newYwwLagre'));

      if (JSON.parse(localStorage.getItem('prpductnewlist')).iscolor == 0) {
        this.YwwLagre.imageid = 0      }
      if (JSON.parse(localStorage.getItem('prpductnewlist')).iscolor == 1) {
        this.YwwLagre = newYwwLagre;      }
    }
    if (localStorage.getItem("newYwwpicRight") != null) {
      var newYwwpicRight = JSON.parse(localStorage.getItem('newYwwpicRight'));

      if (JSON.parse(localStorage.getItem('prpductnewlist')).iscolor == 0) {
        this.YwwpicRight.imageid = 0      }
      if (JSON.parse(localStorage.getItem('prpductnewlist')).iscolor == 1) {
        this.YwwpicRight = newYwwpicRight;      }
    }
    if (localStorage.getItem("newXiancai") != null) {
      var newXiancai = JSON.parse(localStorage.getItem('newXiancai'));

      if (JSON.parse(localStorage.getItem('prpductnewlist')).iscolor == 0) {
        this.Xiancai.id = 0      }
      if (JSON.parse(localStorage.getItem('prpductnewlist')).iscolor == 1) {
        this.Xiancai = newXiancai;      }

    }
    if (localStorage.getItem("newBaozhaung") != null) {
      var newBaozhaung = JSON.parse(localStorage.getItem('newBaozhaung'));

      if (JSON.parse(localStorage.getItem('prpductnewlist')).iscolor == 0) {
        this.Baozhuang.id = 0      }
      if (JSON.parse(localStorage.getItem('prpductnewlist')).iscolor == 1) {
        this.Baozhuang = newBaozhaung;      }

    }
    if (localStorage.getItem("newaddinfo") != null) {
      var list3 = JSON.parse(localStorage.getItem('newaddinfo'));

      if (JSON.parse(localStorage.getItem('prpductnewlist')).iscolor == 0) {
        this.addinfo.name = '';//包装盒刻字
        this.addinfo.style = '';//款式
        this.addinfo.quality = '';//材质
        this.addinfo.elseask = '';//其他要求
      }
      if (JSON.parse(localStorage.getItem('prpductnewlist')).iscolor == 1) {
        this.addinfo == list3;      }

    }
    if (localStorage.getItem("newAllSum") != null) {
      var newAllSum = JSON.parse(localStorage.getItem('newAllSum'));
      this.AllSum = newAllSum
    } else {
      this.AllSum = 0
    }
    if (localStorage.getItem("newPnumber") != null) {
      var newPnumber = JSON.parse(localStorage.getItem('newPnumber'));
      this.Pnumber = newPnumber
    } else {
      this.Pnumber = 1
    }

    window.screenWidth = document.body.clientWidth;
    this.daohang = window.screenWidth > 1024 ? true : false;
    this.getprovinceList();
    this.getdistList();
    this.getukey();
    this.weixinif();
    if(this.$route.query.productmoreid && this.oderstyle==0  ){
        this.productmoreshow=1
      
        if(localStorage.getItem('prpductnewlist')){

             var list = JSON.parse(localStorage.getItem('prpductnewlist'));
              if(this.$route.query.productmoreid == 1){
            this.zhprice=list.cprice
            var a= sessionStorage.getItem("newchooseprice")
            if(a){
                this.zhprice=a
            // console.log("this.zhprice:"+this.zhprice)
            }
           
        }else if(this.$route.query.productmoreid == 2){
            this.zhprice=list.aprice
            var a= sessionStorage.getItem("newchooseprice")
            if(a){
                this.zhprice=a
            // console.log("this.zhprice:"+this.zhprice)
            }
            
        }
        else if(this.$route.query.productmoreid == 3){
            this.zhprice=list.bprice
            var a= sessionStorage.getItem("newchooseprice")
            if(a){
                this.zhprice=a
            // console.log("this.zhprice:"+this.zhprice)
            }
           
           
        }
        }
    }

    
  },
  mounted () {
    // this.qrcodeScan();
    // 注：需在mounted里触发qrcodeScan函数
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;

        this.daohang = window.screenWidth > 1024 ? true : false;
      })();
    };

   this.getproductlist();
  },
  methods: {
      show(){
// console.log("zk:"+this.zk)
// console.log("AllSum:"+this.AllSum)
// console.log("AllSum:"+this.AllSum)

      },
    getproductlist () {

      var para = {
        id: this.$route.query.childid
      };
    //   console.log(para)
      
      getpro(para).then(res => {
        this.loading = true
        this.oderimg = res.data.pro.image
        this.productlist=res.data.pro
        this.productid=res.data.pro.id
        // console.log("产品详情列表请求成功", res.data);
        // this.cpxxshow=true
        // this.productmessageList = res.data.pro
        // console.log(this.$route.query.productmoreid)
         if(this.$route.query.type){
                 this.zhprice=sessionStorage.getItem("newchooseprice")
            }
        if (this.$route.query.productmoreid == 1) {
          this.zhprice = res.data.pro.cprice


        }
        else if (this.$route.query.productmoreid == 2) {
          this.zhprice = res.data.pro.aprice
         
        }
        else if (this.$route.query.productmoreid == 3) {
          this.zhprice = res.data.pro.bprice
           
        } else {
          this.zhprice = res.data.pro.price
         if(localStorage.getItem('zhprice2')) {
             this.zhprice=localStorage.getItem('zhprice2')
         }
          
        }
        this.getpoinxxlist()
        this.AllSum = res.data.pro.price
        this.$store.dispatch("ChangeProductlist", res.data.pro);
        this.$store.dispatch("ChangeAllSum", res.data.pro.price);
        localStorage.setItem('zhprice', this.zhprice)
        res => {
          console.info("调用失败", res);
        };
      });
    },
    odersyle () {
      if (this.$route.query.oderstyle) {
        this.oderstyle = this.$route.query.oderstyle
        this.getotheroder();
      }
      else if (!this.$route.query.oderstyle) {
        if (this.$route.query.productmoreid && !this.$route.query.childid) {
          if (this.$route.query.productmoreid == 2) {
            this.zk = localStorage.getItem('discount')
            this.AllSum = this.zhprice / localStorage.getItem('discount')
          }

        } else {
          this.oderstyle = 0
          this.gzkxxList();
        }
      }





    },
    //getuky
    getukey () {

      if (localStorage.getItem('newukey') == '' || localStorage.getItem('newukey') == null) {
        this.ukey = 0
      } else {
        this.ukey = localStorage.getItem('newukey')
        
          }
      this.odersyle();
      this.getyhaddress();
      this.getpoinxxlist();
      this.loading = true

      if (this.childid == -1 && this.oderstyle == 0 && this.ukey !== 0) {

        if (this.iscolor == 0) {
          var newAllSum = JSON.parse(localStorage.getItem('newAllSum'));
          this.zhprice = newAllSum * localStorage.getItem('discount')
          this.AllSum = newAllSum
        } if (this.iscolor !== 0) {
          if (!this.$route.query.productmoreid) {
            if (localStorage.getItem('discount')) {
              var newAllSum = JSON.parse(localStorage.getItem('newAllSum'));
              this.zhprice = newAllSum
              this.AllSum = newAllSum / localStorage.getItem('discount')
            }
          }

        }

      }

    },
    getpoinxxlist () {
      var para = {

        ukey: this.ukey,
        proid: this.productid,
        price: this.zhprice
      };

      getpoinxx(para).then(res => {
        if (res.data.error_code == 200) {
          this.point = res.data.point

          this.jyzshow = true
        } else {
          this.jyzshow = false
          console.info("请求失败", err);
        }
      }).catch(err => { console.info("调用失败", err); })
    },
    getyhaddress () {
       
      var para = {

        ukey: this.ukey,
      };
      getyhaddress(para).then(res => {
        if (res.data.error_code == 200) {
          //   this.otherlist = res.data.datat
          this.message.area.province = res.data.data.sf
          this.message.area.city = res.data.data.cs
          this.message.area.dist = res.data.data.xc
          this.message.Consignee = res.data.data.names
          this.message.tel = res.data.data.phone
          this.message.address = res.data.data.address

        //   console.log("会员地址成功", res.data.data);
          this.getprovinceList()
          this.getcityList();
          this.getdistList()
        } else {
          console.info("调用失败a", res);
        }
      }).catch(err => { console.info("调用失败b", err); })
    },

    //外部订单
    getotheroder () {

      var para = {
        ddbh: this.$route.query.ddbh,
        ukey: this.ukey,
      };
      getotheroder(para).then(res => {
        if (res.data.error_code == 200) {
          this.otherlist = res.data.datat
          this.message.area.province = res.data.data.sf
          this.message.area.city = res.data.data.cs
          this.message.area.dist = res.data.data.xc
          this.message.Consignee = res.data.data.names
          this.message.tel = res.data.data.phone
          this.message.address = res.data.data.address
          this.orderprice = res.data.data.prices
          this.zhprice = res.data.data.zhprice
          this.getprovinceList()
          this.getcityList();
          this.getdistList()
        } else {
          console.info("调用失败a", res);
        }
      }).catch(err => { console.info("调用失败b", err); })
    },
    weixinif () {

      var ua = navigator.userAgent.toLowerCase();

      var isWeixin = ua.indexOf('micromessenger') != -1;

      if (isWeixin == false) {
        this.weixin = 0
      } else {
        this.weixin = 1
        this.paylist=this.wxpaylist
      }
      if (isWeixin) {
        return true;
      } else {
        return false;
      }

    },
    // 折扣价
    gzkxxList () {
      
      var para = {
        token: sessionStorage.getItem('token'),
        ukey: this.ukey,
      };
      gzkxx(para).then(res => {
        if (res.data.error_code == 200) {
          this.zk = res.data.zk
          let zks = localStorage.getItem('discount')
          if (this.ukey != 0 && this.oderstyle == 0) {
            this.zhprice = this.AllSum
            if (this.childid == -1) {
              this.zhprice = this.AllSum * res.data.zk
            }
          } 
          else {
            this.zk = res.data.zk

            this.zhprice = this.AllSum * res.data.zk
            localStorage.setItem('discount', res.data.zk)
            localStorage.setItem('zhprice', this.AllSum * res.data.zk)
          }
          // if(this.oderstyle==0){
          //     if(localStorage.getItem('discount')==1&&this.ukey!==0){   
          //         if(this.productlist.iscolor==0)  {
          //          this.zk = res.data.zk
          //             this.zhprice = this.AllSum*res.data.zk
          //             localStorage.setItem('discount', res.data.zk)
          //             localStorage.setItem('zhprice',this.AllSum*res.data.zk)
          //         }                    
          //     }
          //     

          // }
          this.getpoinxxlist();


        } else {
          console.info("调用失败", res);
        }
      }).catch(err => { console.info("调用失败", err); })
    },
    qrcodeScan () {//生成二维码
      let qrcode = new QRCode('qrcode', {
        width: 200,  // 二维码宽度 
        height: 200, // 二维码高度
        text: this.codeurl
      })
    },
    payid (items) {
      this.message.pay = items.id;
      this.payname = items.name

      //   console.log('message.pay:'+ this.message.pay)
      //   console.log('payid:'+ items.id)
    },
    payto () {


      if (this.message.Consignee == '' || this.message.Consignee == null) {
        this.$message({
          message: "请输入收货人",
          type: 'error'
        });
        return;
      }
      if (this.message.area.province == '' || this.message.area.province == null) {
        this.$message({
          message: "请输入省份",
          type: 'error'
        });
        return;
      }
      if (this.message.area.city == '' || this.message.area.city == null) {
        this.$message({
          message: "请选择城市",
          type: 'error'
        });
        return;
      }
      // if(this.message.area.dist==''||this.message.area.dist==null) {
      // 			this.$message({
      // 				message: "请选择县区",
      // 				type: 'error'
      // 			});
      // 			return;
      // 		}
      if (this.message.address == '' || this.message.address == null) {
        this.$message({
          message: "请输入详细地址",
          type: 'error'
        });
        return;
      }
      if (!this.message.tel) {
        this.$message({
          message: "请输入电话号码",
          type: 'error'
        });
        return;
      }

    //   if (this.message.tel!=="") {
    //     var reg = /^[1][3-8]\d{9}$|^([6|9])\d{7}$|^[0][9]\d{8}$|^[6]([8|6])\d{5}$/;
    //     if (!reg.test(this.message.tel)) {
    //       this.$message({
    //         message: "请输入正确的手机号码",
    //         type: 'error'
    //       });
    //       return;
    //     }
    //   }
      if (this.message.pay == '' || this.message.pay == null) {
        this.$message({
          message: "请选择支付方式",
          type: 'error'
        });
        return;
      }

      var self = this;

      var para = {
        token: sessionStorage.getItem('token'),
        ukey: this.ukey,
        Consignee: this.message.Consignee,//收货人
        sfid: this.message.area.province,//	省份id
        csid: this.message.area.city,//城市id
        qxid: this.message.area.dist,//区县id
        address: this.message.address,//详细地址
        tel: this.message.tel,//电话号码
        pay: this.message.pay,//支付方式(1:支付宝，3:银联支付)
        id: this.productlist.id,//产品ID
        lcolorid: this.YwwpicRight.imageid,//产品颜色id(右耳)
        rcolorid: this.YwwLagre.imageid,//产品颜色id(左耳)
        xcid: this.Xiancai.id,//线材id
        bzid: this.Baozhuang.id,//包装盒id
        name: this.addinfo.name,//包装盒刻字
        style: this.addinfo.style,//款式
        quality: this.addinfo.quality,//材质
        else: this.addinfo.elseask,//其他要求
        number: this.Pnumber,//产品数量
        price: this.AllSum,
        zhprice: this.zhprice,
        iswx: this.weixin,
        odersyle: this.oderstyle,
        ddbh: this.$route.query.ddbh,
        note:this.note,
      };
      console.info(para);
      gettjddxx(para).then(res => {
        // 微信端
        if (this.weixin == 1) {

          window.location.href = res.data.urlxx

        } else {
          if (this.message.pay == 2) {
            // console.log("二维码地址", res.data.code_url);
            this.codeurl = res.data.code_url
            if (this.ukey == 0) {
              alert('请先登录')
              if (this.productlist.iscolor == 0) {
                window.location.href = 'http://shop.qdc.com/member/login.html?lx=1&fl=1'
              } else {
                window.location.href = 'http://shop.qdc.com/member/login.html?lx=1&fl=2'
              }

            } else {
              this.$router.push({
                path: '/pay',
                query: {
                  codeurl: res.data.code_url,
                  orderid: res.data.ddbh
                }

              });
            }

          }
          if (this.message.pay == 1) {
            if (this.ukey == 0) {
              alert('请先登录')
              if (this.productlist.iscolor == 0) {
                window.location.href = 'http://shop.qdc.com/member/login.html?lx=1&fl=1'
              } else {
                window.location.href = 'http://shop.qdc.com/member/login.html?lx=1&fl=2'
              }

            } else {
              window.location.href = res.data.urlxx
            }

          }

        }


        res => {
          console.info("调用失败", res);
        };
      });
      //         if(this.oderstyle==1){
      //               console.log('231435')
      //   localStorage.setItem('zhprice',this.orderprice)
      //           }else{
      //   localStorage.setItem('zhprice',this.zhprice)
      //           }
      localStorage.setItem('zhprice', this.zhprice)
      //    this.$store.dispatch("ChangeAllsum", this.zhprice);
    },

    getprovinceList () {
      var self = this;

      var para = {

      };

      getregxx(para).then(res => {
        // console.log("省份请求成功", res.data);
        self.provinceList = res.data.sf;

        res => {
          console.info("调用失败", res);
        };
      });
      this.getcityList();
    },
    getcityList () {
      var self = this;

      var para = {
        sfid: this.message.area.province
      };
      getregcs(para).then(res => {
        // console.log("城市请求成功", res.data);      
        self.cityList = res.data.cs;
        res => {
          console.info("调用失败", res);
        };
      });
      this.getdistList()
    },
    getdistList () {
      var self = this;

      var para = {
        csid: this.message.area.city
      };
      //   console.log(para);
      getregqx(para).then(res => {
        // console.log("县区请求成功", res.data);
        self.distList = res.data.qx;

        res => {
          console.info("调用失败", res);
        };
      });
    },
    //通过点击按钮显示移动端导航
    showdao () {
      this.daohang = !this.daohang;
    },
    //跳转产品页面
    Toproduct () {
      this.$router.push("/");
      if (window.screenWidth < 1024) {
        this.daohang = !this.daohang;
      }
    },
    //跳转设计页面
    ToDesign () {
      this.$router.push("/Design");
    },
    pcdSelect (data) {
      this.message.area.province = data.province.value;
      this.message.area.city = data.city.value;
      this.message.area.dist = data.area.value;
    },
    // getprovince () {

    //   console.log(this.message.area.province);
    // },
    // getcity () {
    //   console.log(this.message.area.city);
    // },
    // getdist () {
    //   console.log(this.message.area.dist);
    // },
    add: function () {
      this.Pnumber++;
      //   console.log(this.Pnumber);
      this.sum = this.Pnumber * this.sum;
    },
    minus: function () {
      this.Pnumber--;
      //   console.log(this.Pnumber);
      this.sum = this.Pnumber * this.sum;
    }
  }
};
</script>

<style scoped>
@import "../../static/newlayout.css";
.distpicker-address-wrapper /deep/ select {
  float: left;
  padding-left: 15px;
  color: #999;
  font-size: 15px;
  padding: 0px;
  font-family: "微软雅黑";
  width: 171px;
  height: 30px;
  background: #252733 no-repeat right 11px;
  /* -webkit-appearance: none; */
  /* resize: none; */
  border: none;
}
.paycode {
  position: relative;
  width: 250px;
  height: auto;
  min-height: 250px;
  margin: 10px 0;
  padding: 6px 23px;
  border: 1px solid #d3d3d3;
  -webkit-box-shadow: 1px 1px 1px #ccc;
  box-shadow: 1px 1px 1px #ccc;
}
.qrcode {
  margin: 5px 0;
}
.note-input{display: flex;align-items: center;margin-top: 15px;width: 100%;}
.note-input span{width: 45px;display: block;}
.note-input label{width: calc(100% - 45px);}
.note-input textarea {width: 100%;padding: 7px 8px ;background: #252733;height: 100px;color: #999;}
</style>


// WEBPACK FOOTER //
// src/views/OderCenter.vue